
import axios from "axios";
import { useTextTranslate } from "./useTextTranslate";

const TranslatedText = ({ text }) => {

  const translated = useTextTranslate(text);

  return <>{translated}</>;
};

export default TranslatedText;



